import request from '@/utils/request'

// 查询部门列表
export function listDept(query) {
  return request({
    url: '/department/getList',
    method: 'post',
    data: query
  })
}

// 查询部门列表（排除节点）
export function listDeptExcludeChild(deptId) {
  return request({
    url: '/department/getListNotThis/' + deptId,
    method: 'get'
  })
}

// 查询部门详细
export function getDept(deptId) {
  return request({
    url: '/department/getDeptById/' + deptId,
    method: 'get'
  })
}

// 新增部门
export function addDept(data) {
  return request({
    url: '/department/saveAndUpdateDept',
    method: 'post',
    data: data
  })
}

// 修改部门
export function updateDept(data) {
  return request({
    url: '/department/saveAndUpdateDept',
    method: 'post',
    data: data
  })
}

// 删除部门
export function delDept(deptId) {
  return request({
    url: '/department/deleteDept/' + deptId,
    method: 'get'
  })
}


// 根据角色ID查询部门树结构
export function deptTreeSelect(roleId) {
  return request({
    url: '/department/treeDeptselect',
    method: 'post',
    data: {roleId:roleId}
  })
}


// 获取列表数据
export function getDeptListByUserId(data) {
    return request({
        url: '/common/getDeptListByUserId',
        method: 'POST',
        data: data
    })
}


// 状态修改
export function changeStatus(id, status) {
  const data = {
    id,
    status
  }
  return request({
    url: '/department/updateThisById',
    method: 'post',
    data: data
  })
}

// 状态修改
export function updateThisById(data) {
 
  return request({
    url: '/department/updateThisById',
    method: 'post',
    data: data
  })
}

// 获取列表数据
export function getTalbeListByPage(data) {
    return request({
        url: '/common/getDeptTalbeListByPage',
        method: 'POST',
        data: data
    })
}


// 根据id查询
export function selectDeptByIdNoDept(id) {
  return request({
    url: '/department/selectDeptByIdNoDept/' + id,
    method: 'get'
  })
}